module.exports = __webpack_public_path__ + "img/righticon.9ca6d6ba.svg";